import React, { useState } from "react";
import { ArrowRight, Mail } from "lucide-react";
import { subscribe } from "@/lib/api";
import { toast } from "sonner";

export const Newsletter = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const res = await subscribe(email);
      toast.success(res.message || "Subscribed!");
      setEmail("");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not subscribe. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section
      id="newsletter"
      className="relative py-20 md:py-32 px-6 md:px-12 overflow-hidden bg-navy text-white"
      data-testid="newsletter-section"
    >
      <div
        className="absolute inset-0 opacity-30"
        style={{
          backgroundImage:
            "url(https://images.pexels.com/photos/21550490/pexels-photo-21550490.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940)",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-navy via-navy/90 to-navy/40" />

      <div className="relative z-10 max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
        <div>
          <p className="b2t-overline !text-seafoam-400 mb-4">Join the Crew</p>
          <h2 className="font-display text-4xl md:text-5xl font-bold tracking-tight leading-[1.05]">
            10% off your first order.<br />
            <span className="italic font-light text-seafoam-400">Plus drops before they sell out.</span>
          </h2>
        </div>

        <form onSubmit={onSubmit} className="flex flex-col gap-4" data-testid="newsletter-form">
          <div className="flex items-stretch border border-white/30 bg-white/5 backdrop-blur-sm">
            <div className="px-4 flex items-center text-white/50">
              <Mail className="w-4 h-4" strokeWidth={1.5} />
            </div>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your@email.com"
              data-testid="newsletter-email-input"
              className="flex-1 bg-transparent text-white placeholder:text-white/40 px-2 py-4 focus:outline-none text-sm"
            />
            <button
              type="submit"
              disabled={loading}
              data-testid="newsletter-submit"
              className="bg-seafoam text-navy px-6 py-4 text-xs font-bold uppercase tracking-[0.18em] hover:bg-white transition-colors flex items-center gap-2 disabled:opacity-60"
            >
              {loading ? "..." : "Subscribe"}
              <ArrowRight className="w-4 h-4" strokeWidth={2} />
            </button>
          </div>
          <p className="text-xs text-white/50">No spam. Coastal drops, trip stories, and the occasional 10% off.</p>
        </form>
      </div>
    </section>
  );
};
